import { useContext } from 'react'
import styled from 'styled-components'
import PredictionTable from '@app.feature/exam/gsat2024-2/components/Table/PredictionTable'
import { TableColumnType } from '@app.feature/exam/gsat2024-2/components/Table/PredictionTableHead'
import { PredictionOfPassedContainerContext } from '@app.feature/exam/gsat2024-2/context/PredictionOfPassedContainerContext'
import { parseTestResultDate } from '@app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/module/testResult.module'
import { findScrorePosition } from '@app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/passed/spreadScoreInfo/module/findTooltipArea.module'
import SpredScoreInfoTableColumnsMobile from './components/SpredScoreInfoTableColumns.mobile'

type SpreadScoreInfoColumnItem = {
  name: string
  value: number
  isAverageScore?: boolean
  isMyScore?: boolean
}

const SpreadScoreInfoArticleMobile = () => {
  const {
    examReserveInformation,
    examGradingResultDistribution,
    examGradingResultDistributionSameInfo,
    examGradingResultData,
    examTestsData,
    examGradingRankFromTestRate,
    examGradingRankOfSameInfoFromTestRate,
  } = useContext(PredictionOfPassedContainerContext)

  const examDate = parseTestResultDate({
    dateList: examTestsData || [],
    testId: examReserveInformation?.examTest.id || '',
    formatType: 'slash',
  })

  const { averageScoreIndex, myScoreIndex, sameInfoAverageScoreIndex } =
    findScrorePosition({
      myScore: examGradingResultData?.viewerResult.correctCount || 0,
      averageScore: examGradingResultData?.averageScore.correctCount || 0,
      smaeInfoAverageScore:
        examGradingResultData?.sameInfoAverage.correctCount || 0,
    })

  const COLUMNS: TableColumnType<SpreadScoreInfoColumnItem>[] = [
    { id: '0', label: '맞은 문항 수(개)', dataIndex: 'name' },
    {
      id: '1',
      label: '응시자 비율(%)',
      dataIndex: 'value',
      render: (data) => {
        const tooltipType = data.isMyScore
          ? 'myScore'
          : data.isAverageScore
          ? 'average'
          : false

        return (
          <SpredScoreInfoTableColumnsMobile
            tooltipType={tooltipType}
            value={data.value}
          />
        )
      },
    },
  ]

  const spreadScoreInfoAllUser: Array<SpreadScoreInfoColumnItem> =
    examGradingResultDistribution?.map((item, index) => {
      return {
        name: item.range,
        value: item.rate,
        isMyScore: index === myScoreIndex,
        isAverageScore: index === averageScoreIndex,
      }
    }) || []

  const spreadScoreInfoSameInfo =
    examGradingResultDistributionSameInfo?.map((item, index) => {
      return {
        name: item.range,
        value: item.rate,
        isMyScore: index === myScoreIndex,
        isAverageScore: index === sameInfoAverageScoreIndex,
      }
    }) || []

  return (
    <StyledWrapper>
      <div className="table-layout">
        <label>
          {examDate} <br />
          전체 응시생 중&nbsp;
          <span>
            상위&nbsp;
            {examGradingRankFromTestRate}%
          </span>
          <br />
        </label>
        <PredictionTable<SpreadScoreInfoColumnItem>
          tableColumns={COLUMNS}
          tableDataList={spreadScoreInfoAllUser}
        />
      </div>
      <div className="table-layout">
        <label>
          {examDate} <br />
          동일 사업부/직무 응시생 중&nbsp;
          <span>
            상위&nbsp;
            {examGradingRankOfSameInfoFromTestRate}%
          </span>
          <br />
        </label>
        <PredictionTable
          tableColumns={COLUMNS}
          tableDataList={spreadScoreInfoSameInfo}
        />
      </div>
    </StyledWrapper>
  )
}

export default SpreadScoreInfoArticleMobile

const StyledWrapper = styled.article`
  padding: 24px 20px;
  border-radius: 20px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  gap: 36px;

  > .table-layout {
    > label {
      font-size: 15px;
      font-weight: bold;
      line-height: 1.47;
      letter-spacing: -0.6px;
      text-align: center;
      color: #333;
      display: block;
      margin-bottom: 12px;

      > span {
        color: #004eff;
      }
    }
  }
`
